import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './../Styles/CreateGoal.css';  // Adjust the path according to your folder structure

const apiUrl = process.env.REACT_APP_API_URL ;

const CreateGoal = ({ onClose, onGoalCreated }) => {
    const [goalName, setGoalName] = useState('');
    const [description, setDescription] = useState('');
    const [statusMessage, setStatusMessage] = useState('');
    const [statusType, setStatusType] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && !isSubmitting) {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isSubmitting, onClose]);

    const handleCreateGoal = async () => {
        if (!goalName.trim()) {
            setStatusMessage('Goal name cannot be empty');
            setStatusType('warning');
            return;
        }

        if (!description.trim()) {
            setStatusMessage('Goal description cannot be empty');
            setStatusType('warning');
            return;
        }

        setIsSubmitting(true);
        setStatusMessage('');

        try {
            const response = await axios.post(`${apiUrl}/api/create-goal`, {
                goal_name: goalName.trim(),
                description: description.trim(),
                goal_description: goalName.trim()
            });
            setStatusMessage('Goal created successfully!');
            setStatusType('success');
            console.log('Goal creation response:', response);

            if (onGoalCreated) {
                onGoalCreated();
            }

            setTimeout(() => {
                onClose();
            }, 1500);
        } catch (error) {
            setIsSubmitting(false);
            console.error('Error creating goal:', error);
            if (error.response && error.response.status === 409) {
                setStatusMessage('A goal with this name already exists');
                setStatusType('error');
            } else {
                setStatusMessage('Error creating goal. Please try again.');
                setStatusType('error');
            }
        }
    };
    
    return (
        <div className="pms-overlay modal-overlay" onClick={onClose}>
            <div 
                className="pms-modal modal-content create-goal-modal" 
                onClick={(e) => e.stopPropagation()}
                style={{ padding: '28px 32px', maxWidth: '520px', width: '92%', borderRadius: '10px' }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px' }}>
                    <h2 style={{ margin: 0, color: 'var(--text-primary, #0f172a)', fontSize: '20px', fontWeight: '600' }}>
                        Create Goal
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isSubmitting}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '20px',
                            cursor: 'pointer',
                            color: 'var(--text-secondary, #64748b)',
                            padding: '4px',
                            lineHeight: 1
                        }}
                        aria-label="Close"
                    >
                        ✕
                    </button>
                </div>
                
                {statusMessage && (
                    <div
                        className={`create-goal-status ${statusType}`}
                        style={{
                            marginBottom: '16px',
                            padding: '10px 14px',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: '500',
                            backgroundColor: statusType === 'success' ? '#dcfce7' : statusType === 'warning' ? '#fef3c7' : '#fee2e2',
                            color: statusType === 'success' ? '#15803d' : statusType === 'warning' ? '#b45309' : '#b91c1c',
                            border: `1px solid ${statusType === 'success' ? '#86efac' : statusType === 'warning' ? '#fde68a' : '#fca5a5'}`
                        }}
                    >
                        {statusType === 'success' ? '✓ ' : statusType === 'warning' ? '⚠️ ' : '✕ '}
                        {statusMessage}
                    </div>
                )}

                <div className="create-goal-field" style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', fontSize: '14px', color: 'var(--text-primary, #334155)' }}>
                        Goal Name <span style={{ color: '#ef4444' }}>*</span>
                    </label>
                    <input
                        type="text"
                        className="pms-input"
                        style={{ width: '100%', boxSizing: 'border-box' }}
                        value={goalName}
                        onChange={(e) => {
                            setGoalName(e.target.value);
                            if (statusType !== 'success') {
                                setStatusMessage('');
                            }
                        }}
                        placeholder="Enter goal name"
                        disabled={isSubmitting || statusType === 'success'}
                        autoFocus
                    />
                </div>

                <div className="create-goal-field" style={{ marginBottom: '22px' }}>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', fontSize: '14px', color: 'var(--text-primary, #334155)' }}>
                        Goal Description <span style={{ color: '#ef4444' }}>*</span>
                    </label>
                    <textarea
                        className="pms-input"
                        style={{ width: '100%', minHeight: '120px', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit', lineHeight: '1.5' }}
                        value={description}
                        onChange={(e) => {
                            setDescription(e.target.value);
                            if (statusType !== 'success') {
                                setStatusMessage('');
                            }
                        }}
                        placeholder="Enter detailed goal description"
                        disabled={isSubmitting || statusType === 'success'}
                    />
                </div>
                
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button className="create-goal-btn-cancel" onClick={onClose} disabled={isSubmitting}>Cancel</button>
                    <button className="create-goal-btn-submit" onClick={handleCreateGoal} disabled={isSubmitting || statusType === 'success'}>
                        Create
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateGoal;
